import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/features/docs/components/DocsShell.tsx");
